const initState = {
  currentTheme: '',
  currentLang: 'zh-Hans',
  pageLoading: false,
  pageTags: [],
  currentTag: null,
  latestPath: null,
  version: null,
  currentSiteId: '',
  modelTreeProp: '', // 模型树相关数据
  fromOrigin: '', // 判断引入模块的来源
}

const System = {
  namespaced: true,
  state: { ...initState },
  getters: {
    currentSiteId(state) {
      return state.currentSiteId
    },
    fromOrigin(state) {
      return state.fromOrigin
    },
    modelTreeProp(state) {
      return state.modelTreeProp
    },
    currentTheme(state) {
      return state.currentTheme
    },
    currentLang(state) {
      return state.currentLang
    },
    pageLoading(state) {
      return state.pageLoading
    },
    pageTags(state) {
      return state.pageTags
    },
    currentTag(state) {
      return state.currentTag
    },
    latestPath(state) {
      return state.latestPath
    },
    version(state) {
      return state.version
    },
  },
  mutations: {
    resetState(state) {
      // TODO:深克隆失效,只能手动重置
      _.assign(state, {
        currentTheme: 'light',
        currentLang: 'zh-Hans',
        pageLoading: false,
        pageTags: [],
        currentTag: null,
        latestPath: null,
        version: null,
        currentSiteId: '',
        modelTreeProp: '',
        fromOrigin: '',
      })
    },
    updateState(state, { payload }) {
      _.assign(state, payload)
    },
    currentSiteId(state, payload) {
      _.assign(state, {
        currentSiteId: payload,
      })
    },
    fromOrigin(state, payload) {
      _.assign(state, {
        fromOrigin: payload,
      })
    },
    modelTreeProp(state, payload) {
      _.assign(state, {
        modelTreeProp: payload,
      })
    },
    currentTheme(state, payload) {
      _.assign(state, {
        currentTheme: payload,
      })
    },
    currentLang(state, payload) {
      _.assign(state, {
        currentLang: payload,
      })
    },
    ADD_PAGE_TAG(state, payload) {
      state.pageTags.push(payload)
    },
    pageTags(state, payload) {
      _.assign(state, {
        pageTags: payload,
      })
    },
    currentTag(state, payload) {
      _.assign(state, {
        currentTag: payload,
      })
    },
    latestPath(state, payload) {
      _.assign(state, {
        latestPath: payload,
      })
    },
    pageLoading(state, payload) {
      _.assign(state, {
        pageLoading: payload,
      })
    },
    version(state, payload) {
      _.assign(state, {
        version: payload,
      })
    },
  },
  actions: {
    currentSiteId({ commit }, payload) {
      commit('currentSiteId', payload)
    },
    fromOrigin({ commit }, payload) {
      commit('fromOrigin', payload)
    },
    modelTreeProp({ commit }, payload) {
      commit('modelTreeProp', payload)
    },
    currentTheme({ commit }, payload) {
      commit('currentTheme', payload)
    },
    currentLang({ commit }, payload) {
      commit('currentLang', payload)
    },
    addTag({ commit }, payload) {
      commit('ADD_PAGE_TAG', payload)
    },
    pageTags({ commit }, payload) {
      commit('pageTags', payload)
    },
    currentTag({ commit }, payload) {
      commit('currentTag', payload)
    },
    latestPath({ commit }, payload) {
      commit('latestPath', payload)
    },
    pageLoading({ commit }, payload) {
      commit('pageLoading', payload)
    },
    version({ commit }, payload) {
      commit('version', payload)
    },
  },
}

export default System
